module.exports = __webpack_public_path__ + "media/images/pages/careers-week/leroy_david-30356b8f388848a46f8f83fffd384cab.jpg";